import React, {useEffect, useState} from 'react';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import SearchRoundedIcon from '@material-ui/icons/SearchRounded';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import {fade, makeStyles} from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import InputBase from '@material-ui/core/InputBase';
import JString from '@easytech-international-sdn-bhd/jstring';
import Checkbox from '@material-ui/core/Checkbox';
import {Collapse} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
	paper: {
		borderRadius: 12,
		overflow: 'hidden',
	},
	dialogTitle: {
		padding: theme.spacing(3, 3, 2, 3),
	},
	titleRow: {
		display: 'flex',
		alignItems: 'flex-start',
		justifyContent: 'space-between',
		gap: theme.spacing(2),
	},
	titlePrimary: {
		fontSize: '1.25rem',
		fontWeight: 600,
		lineHeight: 1.3,
		color: theme.palette.text.primary,
	},
	titleSubtitle: {
		fontSize: '0.8125rem',
		color: theme.palette.text.secondary,
		marginTop: theme.spacing(0.5),
	},
	segmented: {
		display: 'inline-flex',
		backgroundColor: fade(theme.palette.text.primary, 0.06),
		borderRadius: 8,
		padding: 2,
		flexShrink: 0,
	},
	segment: {
		minWidth: 80,
		color: theme.palette.text.secondary,
		fontWeight: 500,
		textTransform: 'none',
		borderRadius: 6,
		padding: theme.spacing(0.5, 1.5),
		'&:hover': {backgroundColor: 'transparent'},
	},
	segmentActive: {
		minWidth: 80,
		color: '#000',
		backgroundColor: theme.palette.primary.main,
		fontWeight: 700,
		textTransform: 'none',
		borderRadius: 6,
		padding: theme.spacing(0.5, 1.5),
		boxShadow: `0 2px 6px ${fade(theme.palette.primary.main, 0.4)}`,
		'&:hover': {
			backgroundColor: theme.palette.primary.main,
		},
	},
	searchRow: {
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing(1.5),
		marginTop: theme.spacing(2),
	},
	search: {
		position: 'relative',
		flex: 1,
		borderRadius: 12,
		backgroundColor: fade(theme.palette.text.primary, 0.04),
		border: `1px solid ${fade(theme.palette.text.primary, 0.08)}`,
		transition: theme.transitions.create(
			['background-color', 'box-shadow', 'border-color'],
			{duration: 200}
		),
		'&:hover': {
			borderColor: fade(theme.palette.text.primary, 0.16),
		},
		'&:focus-within': {
			borderColor: theme.palette.primary.main,
			boxShadow: `0 0 0 3px ${fade(theme.palette.primary.main, 0.16)}`,
		},
	},
	searchIcon: {
		padding: theme.spacing(0, 1.5),
		height: '100%',
		position: 'absolute',
		pointerEvents: 'none',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		color: theme.palette.text.secondary,
	},
	inputRoot: {
		color: theme.palette.text.primary,
		width: '100%',
	},
	inputInput: {
		padding: theme.spacing(1.25, 1, 1.25, 0),
		paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
		fontSize: '0.9375rem',
		width: '100%',
	},
	checkAllBtn: {
		flexShrink: 0,
		textTransform: 'none',
		fontWeight: 600,
		color: theme.palette.text.primary,
		borderRadius: 8,
		padding: theme.spacing(1, 1.5),
		'&:hover': {
			backgroundColor: fade(theme.palette.text.primary, 0.06),
		},
	},
	titleLeft: {
		display: 'flex',
		alignItems: 'center',
		gap: theme.spacing(1),
		flexWrap: 'wrap',
	},
	selectionBadge: {
		display: 'inline-flex',
		alignItems: 'center',
		padding: theme.spacing(0.25, 1),
		borderRadius: 999,
		backgroundColor: fade(theme.palette.primary.main, 0.16),
		color: theme.palette.type === 'light' ? '#7a6f00' : theme.palette.primary.main,
		fontSize: '0.6875rem',
		fontWeight: 700,
		letterSpacing: '0.06em',
		textTransform: 'uppercase',
	},
	dialogContent: {
		padding: 0,
		borderTop: `1px solid ${theme.palette.divider}`,
		height: 500,
	},
	listItem: {
		cursor: 'pointer',
		transition: theme.transitions.create('background-color', {duration: 150}),
		'&:hover': {
			backgroundColor: theme.palette.action.hover,
		},
	},
	listItemSelected: {
		backgroundColor: fade(theme.palette.primary.main, 0.08),
		'&:hover': {
			backgroundColor: fade(theme.palette.primary.main, 0.12),
		},
	},
	listItemSearchMatch: {
		backgroundColor: fade(theme.palette.primary.main, 0.04),
	},
	itemName: {
		fontSize: '0.9375rem',
		fontWeight: 500,
		color: theme.palette.text.primary,
	},
	itemNameSelected: {
		fontWeight: 600,
	},
	itemNameMatch: {
		fontWeight: 700,
	},
	badge: {
		display: 'inline-flex',
		alignItems: 'center',
		marginLeft: theme.spacing(1),
		padding: theme.spacing(0.25, 0.75),
		borderRadius: 4,
		fontSize: '0.6875rem',
		fontWeight: 700,
		letterSpacing: '0.04em',
		textTransform: 'uppercase',
	},
	badgeGroup: {
		backgroundColor: fade('#4caf50', 0.16),
		color: '#4caf50',
	},
	badgeType: {
		backgroundColor: fade(theme.palette.text.primary, 0.08),
		color: theme.palette.text.secondary,
	},
	badgeMatch: {
		backgroundColor: fade(theme.palette.primary.main, 0.24),
		color: theme.palette.type === 'light' ? '#7a6f00' : theme.palette.primary.main,
	},
	expandBtn: {
		padding: theme.spacing(0.5),
	},
	pathSeparator: {
		height: 1,
		backgroundColor: theme.palette.divider,
		margin: theme.spacing(1, 2),
	},
	emptyState: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		justifyContent: 'center',
		padding: theme.spacing(6, 2),
		gap: theme.spacing(1),
		height: '100%',
	},
	emptyIcon: {
		fontSize: 56,
		color: theme.palette.text.disabled,
		opacity: 0.4,
		marginBottom: theme.spacing(1),
	},
	emptyTitle: {
		fontSize: '1rem',
		fontWeight: 600,
		color: theme.palette.text.secondary,
	},
	emptySubtitle: {
		fontSize: '0.8125rem',
		color: theme.palette.text.disabled,
	},
	scrollContainer: {
		overflow: 'auto',
		height: '100%',
		'&::-webkit-scrollbar': {width: 8},
		'&::-webkit-scrollbar-track': {backgroundColor: 'transparent'},
		'&::-webkit-scrollbar-thumb': {
			backgroundColor: fade(theme.palette.text.primary, 0.2),
			borderRadius: 4,
			'&:hover': {
				backgroundColor: fade(theme.palette.text.primary, 0.32),
			},
		},
		scrollbarWidth: 'thin',
		scrollbarColor: `${fade(theme.palette.text.primary, 0.2)} transparent`,
	},
	actions: {
		padding: theme.spacing(2, 3),
		gap: theme.spacing(1),
		borderTop: `1px solid ${theme.palette.divider}`,
	},
	resetBtn: {
		color: theme.palette.error.main,
		fontWeight: 600,
		textTransform: 'none',
		'&:hover': {
			backgroundColor: fade(theme.palette.error.main, 0.08),
		},
	},
	cancelBtn: {
		textTransform: 'none',
		fontWeight: 500,
		borderRadius: 8,
	},
	doneBtn: {
		textTransform: 'none',
		fontWeight: 600,
		borderRadius: 8,
		boxShadow: 'none',
		'&:hover': {
			boxShadow: `0 4px 12px ${fade(theme.palette.primary.main, 0.32)}`,
		},
	},
	doneCount: {
		marginLeft: theme.spacing(0.5),
		fontWeight: 700,
	},
	spacer: {flex: 1},
	checkbox: {
		padding: theme.spacing(1),
	},
}));

export default function VirtualListHierarchical({setClose, open, title, data, language, limit, filteration, selected, enabledCheckAll = true}) {
	const classes = useStyles();
	const [hierarchicalData, setHierarchicalData] = useState([]);
	const [flattenedData, setFlattenedData] = useState([]);
	const [searchResults, setSearchResults] = useState([]);
	const [expandedNodes, setExpandedNodes] = useState({});
	const [checkedList, setCheckedList] = useState({});
	const [confirmedList, setConfirmedList] = useState({});
	const [listReturn, setListReturn] = useState([]);
	const [status, setStatus] = useState(1);
	const [searchQuery, setSearchQuery] = useState('');

	const buildHierarchy = (items) => {
		const itemMap = {};
		const rootItems = [];
		items.forEach(item => {
			itemMap[item.type_id] = {...item, children: []};
		});
		items.forEach(item => {
			if (item.type_parent_id && itemMap[item.type_parent_id]) {
				itemMap[item.type_parent_id].children.push(itemMap[item.type_id]);
			} else {
				rootItems.push(itemMap[item.type_id]);
			}
		});
		return rootItems;
	};

	const flattenHierarchy = (items, level = 0) => {
		let result = [];
		items.forEach(item => {
			result.push({
				...item,
				level,
				name: item.type_name,
				value: item.type_name,
				secondary: item.type_name,
				status: parseInt(item.type_status),
				isFolder: item.is_leaf === '0',
			});
			if (item.children && item.children.length > 0) {
				result = result.concat(flattenHierarchy(item.children, level + 1));
			}
		});
		return result;
	};

	const getAllChildrenIds = (item) => {
		let ids = [item.type_id];
		if (item.children) {
			item.children.forEach(child => {
				ids = ids.concat(getAllChildrenIds(child));
			});
		}
		return ids;
	};

	const findItemInHierarchy = (items, targetId) => {
		for (let item of items) {
			if (item.type_id === targetId) return item;
			if (item.children) {
				const found = findItemInHierarchy(item.children, targetId);
				if (found) return found;
			}
		}
		return null;
	};

	const getItemPath = (item, allItems) => {
		const path = [];
		let currentItem = item;
		while (currentItem) {
			path.unshift(currentItem);
			if (currentItem.type_parent_id) {
				currentItem = allItems.find(i => i.type_id === currentItem.type_parent_id);
			} else {
				break;
			}
		}
		return path;
	};

	const buildSearchHierarchy = (matchedItems, allFlatData) => {
		const result = [];
		matchedItems.forEach(matchedItem => {
			const path = getItemPath(matchedItem, allFlatData);
			path.forEach((pathItem, index) => {
				result.push({
					...pathItem,
					level: index,
					isSearchMatch: pathItem.type_id === matchedItem.type_id,
					pathId: `${matchedItem.type_id}-path`,
				});
			});
		});
		return result;
	};

	useEffect(() => {
		if (data && data.length > 0) {
			let hierarchyData = data;
			const isAlreadyHierarchical = data.some(item => item.children !== undefined);
			if (!isAlreadyHierarchical) {
				if (filteration) {
					const filteredData = data.filter(item => parseInt(item.type_status) === status);
					hierarchyData = buildHierarchy(filteredData);
				} else {
					hierarchyData = buildHierarchy(data);
				}
			} else {
				if (filteration) {
					const filterHierarchy = (items) => {
						return items.filter(item => parseInt(item.type_status) === status)
							.map(item => ({
								...item,
								children: item.children ? filterHierarchy(item.children) : [],
							}));
					};
					hierarchyData = filterHierarchy(data);
				}
			}
			setHierarchicalData(hierarchyData);
			const flattened = flattenHierarchy(hierarchyData);
			setFlattenedData(flattened);
		}
	}, [open, data, status]);

	useEffect(() => {
		if (open) {
			if (selected && selected.length > 0) {
				var tmp = Object.assign({});
				for (var i = 0; i < selected.length; i++) {
					const item = selected[i];
					const key = item.type_id || item.value;
					tmp[`${key}`] = selected[i];
				}
				setCheckedList(tmp);
				setConfirmedList(tmp);
			} else {
				setCheckedList(confirmedList);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [open, selected]);

	const onSelectChange = (_cur) => {
		const {value, isFolder, type_id} = _cur;
		var tmp = Object.assign({}, checkedList);
		const itemKey = type_id || value;

		if (isFolder) {
			const item = findItemInHierarchy(hierarchicalData, _cur.type_id);
			if (item) {
				const allChildrenIds = getAllChildrenIds(item);
				const isCurrentlySelected = itemKey in tmp;
				if (isCurrentlySelected) {
					allChildrenIds.forEach(id => {
						const childItem = flattenedData.find(it => it.type_id === id);
						if (childItem) {
							const childKey = childItem.type_id || childItem.value;
							delete tmp[`${childKey}`];
						}
					});
				} else {
					allChildrenIds.forEach(id => {
						const childItem = flattenedData.find(it => it.type_id === id);
						if (childItem) {
							const childKey = childItem.type_id || childItem.value;
							tmp[`${childKey}`] = {
								name: childItem.name || childItem.type_name,
								value: childItem.value || childItem.type_name,
								type_id: childItem.type_id,
							};
						}
					});
				}
			}
		} else {
			if (itemKey in tmp) {
				delete tmp[`${itemKey}`];
			} else {
				tmp[`${itemKey}`] = {
					name: _cur.name,
					value: _cur.value,
					type_id: _cur.type_id,
				};
			}
		}

		setCheckedList(tmp);
	};

	const toggleExpanded = (nodeId) => {
		setExpandedNodes(prev => ({...prev, [nodeId]: !prev[nodeId]}));
	};

	const checkAll = () => {
		var tmp = Object.assign({}, checkedList);
		const dataToUse = searchQuery ? searchResults : flattenedData;
		for (var i = 0; i < dataToUse.length; i++) {
			const item = dataToUse[i];
			const {name, value, hide, type_id} = item;
			const itemKey = type_id || value;
			if (hide === false || hide === undefined) {
				if (itemKey in tmp) {
					delete tmp[`${itemKey}`];
				} else {
					tmp[`${itemKey}`] = {
						name: name || item.type_name,
						value: value || item.type_name,
						type_id: type_id,
					};
				}
			}
		}
		setCheckedList(tmp);
	};

	const savecustomer = () => {
		const list = Object.values(checkedList);
		var selectedData = [];
		for (var i = 0; i < list.length; i++) {
			selectedData.push({
				name: list[i].name,
				value: list[i].type_id,
			});
		}
		setConfirmedList(checkedList);
		setListReturn(selectedData);
		setClose(selectedData);
	};

	const closeReset = () => {
		setSearchResults([]);
		setListReturn([]);
		setStatus(1);
		setSearchQuery('');
		setExpandedNodes({});
	};

	const hardReset = () => {
		setHierarchicalData([]);
		setFlattenedData([]);
		setCheckedList({});
		setConfirmedList({});
		closeReset();
	};

	const renderHierarchicalItem = (item, level = 0) => {
		const itemName = item.name || item.type_name;
		const itemValue = item.value || item.type_name;
		const isFolder = item.isFolder !== undefined ? item.isFolder : (item.is_leaf === '0');
		const itemKey = item.type_id || itemValue;
		const isChecked = itemKey in checkedList;
		const isExpanded = expandedNodes[item.type_id];
		const hasChildren = item.children && item.children.length > 0;

		const selectItem = {...item, name: itemName, value: itemValue, isFolder};

		return (
			<React.Fragment key={item.type_id}>
				<ListItem
					button
					disabled={item.hide === true}
					onClick={() => item.hide ? null : onSelectChange(selectItem)}
					className={`${classes.listItem} ${isChecked ? classes.listItemSelected : ''}`}
					style={{paddingLeft: level * 24 + 16}}>
					<Checkbox
						id={item.type_id}
						className={classes.checkbox}
						disabled={item.hide === true}
						tabIndex={-1}
						disableRipple
						checked={isChecked}
						color="primary"
					/>
					<ListItemText
						primary={
							<div style={{display: 'flex', alignItems: 'center'}}>
								<span className={`${classes.itemName} ${isChecked ? classes.itemNameSelected : ''}`}>
									{itemName}
								</span>
								<span className={`${classes.badge} ${isFolder ? classes.badgeGroup : classes.badgeType}`}>
									{isFolder ? 'Group' : 'Type'}
								</span>
							</div>
						}
						primaryTypographyProps={{
							component: 'div',
							style: {textDecorationLine: item.hide ? 'line-through' : undefined},
						}}
					/>
					{hasChildren && (
						<IconButton
							className={classes.expandBtn}
							size="small"
							onClick={(e) => {
								e.stopPropagation();
								toggleExpanded(item.type_id);
							}}>
							{isExpanded ? <ExpandLess/> : <ExpandMore/>}
						</IconButton>
					)}
				</ListItem>
				{hasChildren && (
					<Collapse in={isExpanded} timeout="auto" unmountOnExit>
						{item.children.map(child => renderHierarchicalItem(child, level + 1))}
					</Collapse>
				)}
			</React.Fragment>
		);
	};

	const renderSearchResults = () => {
		const results = [];
		let lastPathId = null;

		searchResults.forEach((item, index) => {
			const itemName = item.name || item.type_name;
			const itemValue = item.value || item.type_name;
			const isFolder = item.isFolder !== undefined ? item.isFolder : (item.is_leaf === '0');
			const itemKey = item.type_id || itemValue;
			const isChecked = itemKey in checkedList;
			const isSearchMatch = item.isSearchMatch;
			const level = item.level || 0;
			const currentPathId = item.pathId;

			if (currentPathId !== lastPathId && lastPathId !== null) {
				results.push(<div key={`separator-${index}`} className={classes.pathSeparator}/>);
			}
			lastPathId = currentPathId;

			const selectItem = {...item, name: itemName, value: itemValue, isFolder};

			results.push(
				<ListItem
					button
					disabled={item.hide === true}
					onClick={() => item.hide ? null : onSelectChange(selectItem)}
					key={`search-${item.type_id}-${currentPathId}`}
					className={`${classes.listItem} ${isChecked ? classes.listItemSelected : (isSearchMatch ? classes.listItemSearchMatch : '')}`}
					style={{paddingLeft: level * 24 + 16}}>
					<Checkbox
						id={`${item.type_id}-${currentPathId}`}
						className={classes.checkbox}
						disabled={item.hide === true}
						tabIndex={-1}
						disableRipple
						checked={isChecked}
						color="primary"
					/>
					<ListItemText
						primary={
							<div style={{display: 'flex', alignItems: 'center'}}>
								<span className={`${classes.itemName} ${isChecked ? classes.itemNameSelected : (isSearchMatch ? classes.itemNameMatch : '')}`}>
									{itemName}
								</span>
								<span className={`${classes.badge} ${isFolder ? classes.badgeGroup : classes.badgeType}`}>
									{isFolder ? 'Group' : 'Type'}
								</span>
								{isSearchMatch && (
									<span className={`${classes.badge} ${classes.badgeMatch}`}>Match</span>
								)}
							</div>
						}
						primaryTypographyProps={{
							component: 'div',
							style: {textDecorationLine: item.hide ? 'line-through' : undefined},
						}}
					/>
				</ListItem>
			);
		});

		return results;
	};

	function escapeRegex(string) {
		return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
	}

	const onChangeSearchText = (event) => {
		var value = event.target.value;
		setSearchQuery(value);
		var text = JString(escapeRegex(String(value)));

		if (text.isValid()) {
			var search = (text.str).split(' ');
			var matchedItems = [];
			for (let idx = 0; idx < flattenedData.length; idx++) {
				var count = 0;
				const row = flattenedData[idx];
				var searchString = row.value + row.name;
				for (let i = 0; i < search.length; i++) {
					var isFound = JString(searchString).searchDeep(search[i]);
					if ((isFound && filteration && row.status === status) || (isFound && !filteration)) {
						count++;
					}
				}
				if (count === search.length) {
					matchedItems.push(row);
				}
			}
			const hierarchicalSearchResults = buildSearchHierarchy(matchedItems, flattenedData);
			setSearchResults(hierarchicalSearchResults);
		} else {
			setSearchResults([]);
		}
	};

	const selectionCount = Object.keys(checkedList).length;
	const doneDisabled = (typeof (limit) !== 'undefined' && limit > 0) && (selectionCount > limit);
	const hasResults = searchQuery ? searchResults.length > 0 : hierarchicalData.length > 0;

	return (
		<Dialog
			fullScreen={false}
			maxWidth="sm"
			fullWidth
			open={open}
			onClose={() => {}}
			PaperProps={{className: classes.paper}}
			aria-labelledby="max-width-dialog-title">
			<DialogTitle id="max-width-dialog-title" className={classes.dialogTitle} disableTypography>
				<div className={classes.titleRow}>
					<div className={classes.titleLeft}>
						<Typography component="div" className={classes.titlePrimary}>
							{title}
						</Typography>
						<div className={classes.selectionBadge}>
							{selectionCount} {language.selected}
						</div>
					</div>
					{filteration ? (
						<div className={classes.segmented}>
							<Button
								className={status === 1 ? classes.segmentActive : classes.segment}
								onClick={() => setStatus(1)}
								size="small"
								disableRipple>
								{language.active}
							</Button>
							<Button
								className={status === 0 ? classes.segmentActive : classes.segment}
								onClick={() => setStatus(0)}
								size="small"
								disableRipple>
								{language.inactive}
							</Button>
						</div>
					) : null}
				</div>
				<div className={classes.searchRow}>
					<div className={classes.search}>
						<div className={classes.searchIcon}>
							<SearchRoundedIcon/>
						</div>
						<InputBase
							value={searchQuery}
							placeholder={language.search}
							classes={{root: classes.inputRoot, input: classes.inputInput}}
							inputProps={{'aria-label': 'search'}}
							onChange={onChangeSearchText}
						/>
					</div>
					{enabledCheckAll && (
						<Button onClick={() => checkAll()} size="small" className={classes.checkAllBtn}>
							{language.check_all}
						</Button>
					)}
				</div>
			</DialogTitle>
			<DialogContent className={classes.dialogContent}>
				<div className={classes.scrollContainer}>
					{!hasResults ? (
						<div className={classes.emptyState}>
							<SearchRoundedIcon className={classes.emptyIcon}/>
							<Typography className={classes.emptyTitle}>
								{language.no_matches_found}
							</Typography>
							<Typography className={classes.emptySubtitle}>
								{language.try_different_keyword}
							</Typography>
						</div>
					) : searchQuery ? (
						renderSearchResults()
					) : (
						hierarchicalData.map(item => renderHierarchicalItem(item, 0))
					)}
				</div>
			</DialogContent>
			<DialogActions className={classes.actions}>
				<Button
					className={classes.resetBtn}
					onClick={() => {
						setClose({name: 'reset', value: ''});
						hardReset();
					}}
					size="small">
					{language.reset_selection}
				</Button>
				<div className={classes.spacer}/>
				<Button
					variant="outlined"
					className={classes.cancelBtn}
					onClick={() => {
						setClose(false);
						closeReset();
					}}>
					{language.cancel}
				</Button>
				<Button
					variant="contained"
					color="primary"
					className={classes.doneBtn}
					disabled={doneDisabled || selectionCount === 0}
					onClick={() => {
						savecustomer();
						closeReset();
					}}>
					{language.done}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
